import { useState } from "react";
import { MultiSelect } from "~/components/ui/multi-select";
import { ExpandableEventTile } from "./ExpandableEventTile";

export interface Role {
    id: string;
    label: string;
}

export interface Event {
    id: string;
    title: string;
    date: string;
    time: string;
    location?: string;
    eventUrl?: string;
    rolePercentages: Record<string, number>;
}

export interface EventBrowser2Props {
    roles: Role[];
    events: Event[];
}

export function EventBrowser2({ roles, events }: EventBrowser2Props) {
    const [selectedRoleIds, setSelectedRoleIds] = useState<string[]>([]);
    const selectedRoles = roles.filter(role => selectedRoleIds.includes(role.id));

    const roleOptions = roles.map(role => ({
        label: role.label,
        value: role.id
    }));

    return (
        <div className="flex flex-col">
            <div className="sticky top-0 bg-background z-10 py-4 shadow-sm">
                <MultiSelect
                    options={roleOptions}
                    onValueChange={setSelectedRoleIds}
                    placeholder="Who would you like to meet?"
                    maxSelected={5}
                    className="max-w-[320px] mx-auto"
                />
            </div>

            <div className="space-y-4 mt-2">
                {events.map((event) => (
                    <ExpandableEventTile
                        key={event.id}
                        title={event.title}
                        date={event.date}
                        time={event.time}
                        location={event.location}
                        eventUrl={event.eventUrl}
                        selectedRoles={selectedRoles.map(role => ({
                            label: role.label,
                            percentage: event.rolePercentages[role.id] || 0
                        }))}
                    />
                ))}
            </div>
        </div>
    );
} 